module.exports = __webpack_public_path__ + "ba930f130df0201e10f5e432c8397e64.png";